import { reactive } from "vue";

const state = reactive({
  open: false,
  title: "确认删除",
  message: "",
  confirmLabel: "删除",
});

let pending: ((value: boolean) => void) | null = null;

function finish(value: boolean) {
  state.open = false;
  const resolve = pending;
  pending = null;
  resolve?.(value);
}

export function useConfirm() {
  function ask(message: string, options?: { title?: string; confirmLabel?: string }) {
    if (pending) finish(false);
    state.title = options?.title ?? "确认删除";
    state.message = message;
    state.confirmLabel = options?.confirmLabel ?? "删除";
    state.open = true;
    return new Promise<boolean>((resolve) => {
      pending = resolve;
    });
  }

  return { state, ask, finish };
}
